"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = require("dyna-interfaces");
var dyna_object_assign_1 = require("dyna-object-assign");
var dyna_queue_handler_1 = require("dyna-queue-handler");
var dyna_retry_1 = require("dyna-retry");
var dyna_guid_1 = require("dyna-guid");
var DynaNodeClient_1 = require("../DynaNodeClient/DynaNodeClient");
var DynaNodeMessage_1 = require("../DynaNodeMessage/DynaNodeMessage");
var isCommand_1 = require("../utils/isCommand");
var unknownError_1 = require("../utils/unknownError");
var consoleStringify_1 = require("../utils/consoleStringify");
var defaultConnectionRetryConfig = {
    maxRetries: null,
    retryTimeoutBaseMs: 500,
    increasePercentFrom: 5,
    increasePercentTo: 15,
    retryTimeoutMaxMs: 10000,
};
var DynaNodeService = /** @class */ (function () {
    function DynaNodeService(_config) {
        var _this = this;
        this._config = _config;
        this._internalId = dyna_guid_1.guid();
        this._active = false; // Indicates when the Service is started or stopped by the owner. On connection drop and retry, active is still true.
        this._ready = false; // Indicates when the Service is operational. On connection drop and retry, ready is false.
        this._serviceRegistered = false;
        this._isServiceRegistering = false;
        this._initialized = false;
        this._sequentialRetryErrors = 0;
        this._start = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        this._sequentialRetryErrors = 0;
                        return [4 /*yield*/, this._serviceRegistration()];
                    case 1:
                        _a.sent();
                        this._active = true;
                        this._ready = true;
                        if (!this._config.onStart) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._config.onStart()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this._active = false;
                        this._ready = false;
                        this._serviceRegistered = false;
                        this._isServiceRegistering = false;
                        // If it is registering, swallow the error, we don't care about this.
                        // It might be in this state because of retries of failed messages.
                        if (error_1.code !== 1712290735)
                            throw error_1 || unknownError_1.unknownError(1810191201, 'DynaNodeService/start');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.send = function (config) {
            return _this.networkCommandsAreAvailable
                ? _this._dynaNodeClient.send(config)
                : _this._rejectInactiveService('send', config);
        };
        this.sendReceive = function (config) {
            return _this.networkCommandsAreAvailable
                ? _this._dynaNodeClient.sendReceive(config)
                : _this._rejectInactiveService('sendReceive', config);
        };
        this.reply = function (sourceMessage, config) {
            return _this.networkCommandsAreAvailable
                ? _this._dynaNodeClient.reply(sourceMessage, config)
                : _this._rejectInactiveService('reply', config);
        };
        this.fetch = function (config) {
            return _this.networkCommandsAreAvailable
                ? _this._dynaNodeClient.fetch(config)
                : _this._rejectInactiveService('reply', config);
        };
        this.sendToMe = function (_a) {
            var command = _a.command, _b = _a.headers, headers = _b === void 0 ? {} : _b, args = _a.args, data = _a.data, addTraces = _a.addTraces;
            var message = new DynaNodeMessage_1.DynaNodeMessage();
            message.from = _this.serviceAddress;
            message.to = _this.serviceAddress;
            message.command = command;
            message.headers = headers;
            message.args = args;
            message.data = data;
            message.addTracesIfEnabled(addTraces);
            message._addTrace('DynaNode/Service/SendToMe', 'DynaNode: Create message through DynaNodeServer.sendToMe()', _this._traceData);
            _this._handleIncomingMessage(message, true);
        };
        this._processQueuedMessage = function (packedMessage) {
            var message = new DynaNodeMessage_1.DynaNodeMessage();
            message.unPack(packedMessage);
            if (!packedMessage) {
                console.error("DynaNodeService [" + _this.friendlyName + "]: internal error 1902231729, Packed Message has no data", consoleStringify_1.consoleStringify({ packedMessage: packedMessage }));
                return Promise.resolve();
            }
            if (message.headers.dynaNodeTrace) { // Check it too reduce resources of the elapsedTimeInQueue function
                message._addTrace('DynaNode/Service/FROM_QUEUE', 'DynaNode: DynaNodeService process packed queued message', __assign(__assign({}, _this._traceData), { elapsedTimeInQueue: (function () {
                        var addedInQueueTrace = message.traces.concat().reverse().find(function (trace) { return trace.section === 'DynaNode/Service/TO_QUEUE'; });
                        var time = addedInQueueTrace && addedInQueueTrace.date;
                        if (!time)
                            return -1;
                        return Date.now() - time;
                    })() }));
            }
            return _this._processMessage(message);
        };
        this._handleDynaNodeClientConnectionLost = function () {
            if (!_this._active)
                return; // Exit, the service is stopped
            console.warn("DynaNodeService [" + _this.friendlyName + "]: Warn 202001280719 connection with server is lost. It will retry: " + !!_this._startWithRetry);
            _this._ready = false;
            _this._serviceRegistered = false;
            _this._isServiceRegistering = false;
            _this._config.onServerConnectionLost && _this._config.onServerConnectionLost();
            _this._startWithRetry && _this._startWithRetry.start();
        };
        this._handleUnknownCommand = {
            executionTimeout: 2000,
            execute: function (_a) {
                var message = _a.message, reply = _a.reply, next = _a.next;
                if (isCommand_1.isCommandError(message.command)) { // block infinite loops
                    console.warn("DynaNodeService [" + _this.friendlyName + "]: warn 1904160730: Incoming command is an error.", consoleStringify_1.consoleStringify(message.viewSecure));
                }
                else {
                    reply({
                        command: 'error/dyna-node/404/404',
                        updateReplyOfArgs: true,
                        updateReplyOfData: true,
                        updateReplyOfReplyOf: true,
                        data: {
                            code: 404.404,
                            errorType: dyna_interfaces_1.EErrorType.USER,
                            section: _this.friendlyName + "/input",
                            message: "Unknown command, [" + message.command + "] command is not supported from this service",
                        },
                    });
                }
                next();
            },
        };
        this._config = dyna_object_assign_1.dynaObjectAssign({
            compressMessages: true,
            parallelRequests: 5,
            defaultsServiceMessagePriorityValue: 1000,
            defaultExecutionTimeout: 5000,
            onBeforeAnyCommand: function () { return Promise.resolve(); },
        }, this._config);
    }
    DynaNodeService.prototype._rejectInactiveService = function (methodName, sendConfig) {
        return Promise.reject({
            error: 1810161515,
            section: 'DynaNodeService/accessToDynaNodeClientMethods',
            message: "Service is currently not ready, you cannot use it's DynaNodeClient method [" + methodName + "]. This could happen during start() or due to re-connection.",
            errorType: dyna_interfaces_1.EErrorType.APP,
            data: {
                sendConfig: sendConfig,
                serviceStats: this.stats,
            },
        });
    };
    DynaNodeService.prototype._init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this._initialized)
                    return [2 /*return*/];
                this._initialized = true;
                this._messagesQueue = new dyna_queue_handler_1.DynaQueueHandler({
                    parallels: this._config.parallelRequests,
                    onJob: this._processQueuedMessage,
                    memorySet: this._config.disk.set,
                    memoryGet: this._config.disk.get,
                    memoryDel: this._config.disk.del,
                    memoryDelAll: this._config.disk.delAll,
                });
                this._dynaNodeClient = new DynaNodeClient_1.DynaNodeClient({
                    headers: this._config.headers,
                    prefixAddress: (this._config.prefixAddress || 'general') + '-service',
                    compressMessages: this._config.compressMessages,
                    closeInactiveConnectionsInMinutes: undefined,
                    onMessage: function (message) { return _this._handleIncomingMessage(message, false); },
                    onError: function (error) { return console.error("DynaNodeService [" + _this.friendlyName + "]: Error: 1809260707, network error", consoleStringify_1.consoleStringify(error)); },
                    onConnectionClose: this._handleDynaNodeClientConnectionLost,
                });
                this._startWithRetry =
                    this._config.retryConnectionConfig === null // null means to start without retry
                        ? null
                        : (new dyna_retry_1.DynaRetry(dyna_object_assign_1.dynaObjectAssign(defaultConnectionRetryConfig, this._config.retryConnectionConfig || {}, // retryConnectionConfig would be undefined
                        {
                            operation: this._start,
                            onFail: (function (error, retryNo, cancel) {
                                if (error && error.error && error.error.code === 202011040934) {
                                    // Wrong service registration, wrong credentials
                                    cancel();
                                    return;
                                }
                                _this._sequentialRetryErrors++;
                                if (_this._sequentialRetryErrors > 40) {
                                    console.warn("DynaNodeService [" + _this.friendlyName + "]: Error 1911102019: Retry #" + retryNo + " on Service Start. The operation will be not retried any more. Too many failed retries on the row!", consoleStringify_1.consoleStringify(error));
                                    cancel();
                                    return;
                                }
                                console.warn("DynaNodeService [" + _this.friendlyName + "]: Warn 1911102015: Retry #" + retryNo + " on Service Start. The operation will be retried.", consoleStringify_1.consoleStringify(error));
                                if (_this._config.retryConnectionConfig && _this._config.retryConnectionConfig.onFail)
                                    _this._config.retryConnectionConfig.onFail(error, retryNo, cancel);
                            }),
                        })));
                return [2 /*return*/];
            });
        });
    };
    // Start the Service. When this is resolved the Service will be Active and Ready
    DynaNodeService.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this._startWithRetry
                                ? this._startWithRetry.start()
                                : this._start()];
                }
            });
        });
    };
    DynaNodeService.prototype.stop = function (waitForPendingMessages) {
        if (waitForPendingMessages === void 0) { waitForPendingMessages = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._active = false;
                        if (this._startWithRetry && this._startWithRetry.isWorking)
                            this._startWithRetry.cancel();
                        if (!waitForPendingMessages) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._messagesQueue.allDone()];
                    case 1:
                        _a.sent(); // wait all jobs to be completed
                        _a.label = 2;
                    case 2: // wait all jobs to be completed
                    return [4 /*yield*/, this._dynaNodeClient.stopConnections()];
                    case 3:
                        _a.sent();
                        this._ready = false;
                        this._serviceRegistered = false;
                        this._isServiceRegistering = false;
                        if (!this._config.onStop) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._config.onStop()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DynaNodeService.prototype, "serviceAddress", {
        get: function () {
            if (this._serviceAddress)
                return this._serviceAddress;
            if (this._config.serviceRegistration) {
                return this._serviceAddress = this._config.serviceRegistration.serviceConnectionId + "@" + this._config.serviceRegistration.serverDynaNodeAddress;
            }
            else if (this._dynaNodeClient) {
                return this._serviceAddress = this._dynaNodeClient.internalDynamicAddress;
            }
            else {
                return "serviceIsNotYetInitialized";
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeService.prototype, "stats", {
        get: function () {
            return {
                serviceFriendlyName: this.friendlyName,
                dynaNodeClient: this._dynaNodeClient.stats,
                active: this._active,
                ready: this._ready,
                isWorking: this._messagesQueue.isWorking,
                jobsCount: this._messagesQueue.jobsCount,
                config: {
                    prefixAddress: this._config.prefixAddress || 'no prefix address',
                    serviceConnectionId: this._config.serviceRegistration && this._config.serviceRegistration.serviceConnectionId || 'no serviceRegistration',
                    parallelRequests: this._config.parallelRequests || 5,
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeService.prototype.getQueuedMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var packedMessages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._messagesQueue.jobs];
                    case 1:
                        packedMessages = _a.sent();
                        return [2 /*return*/, packedMessages.map(function (packedMessage) {
                                var message = new DynaNodeMessage_1.DynaNodeMessage();
                                message.unPack(packedMessage);
                                return message;
                            })];
                }
            });
        });
    };
    Object.defineProperty(DynaNodeService.prototype, "networkCommandsAreAvailable", {
        get: function () {
            // The network methods are blocked on Services because the connectionId is not valid when the service is not registered.
            // But this is not a case when the Service is used without Service Configuration.
            // This is the case of Workers where is not needed to get registered with a Server.
            return !this._config.serviceRegistration || this._ready;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeService.prototype, "active", {
        // Active is the service that is started, although, due to network interruptions might be not ready.
        get: function () {
            return this._active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeService.prototype, "ready", {
        // Service is active and ready.
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeService.prototype.addCommand = function (commandName, commandConfig) {
        if (this._config.onCommand[commandName]) {
            console.error("DynaNodeService [" + this.friendlyName + "]: Error 1807151023 addCommand, command [" + commandName + "] is already added!");
            return false;
        }
        this._config.onCommand[commandName] = commandConfig;
        return true;
    };
    Object.defineProperty(DynaNodeService.prototype, "unprocessedMessages", {
        get: function () {
            return this._messagesQueue.jobsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeService.prototype, "friendlyName", {
        get: function () {
            return "" + this.serviceAddress + (this._config.prefixAddress && (' / ' + this._config.prefixAddress) || '');
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeService.prototype.sendToMeMessage = function (message) {
        this._handleIncomingMessage(message, true);
    };
    DynaNodeService.prototype.getAvailabilityIndex = function () {
        return this._messagesQueue.jobsCount;
    };
    DynaNodeService.prototype._serviceRegistration = function () {
        var _this = this;
        if (this._serviceRegistered)
            return Promise.resolve();
        if (this._isServiceRegistering)
            return Promise.reject({
                code: 1712290735,
                message: 'Service registration is in progress',
                errorType: dyna_interfaces_1.EErrorType.APP,
                data: {
                    retry: true,
                },
            });
        this._isServiceRegistering = true;
        // No need to registration for dyna node server, the service probably is a Worker
        if (!this._config.serviceRegistration) {
            return Promise.resolve()
                .then(function () {
                _this._serviceRegistered = true;
                _this._isServiceRegistering = false;
            });
        }
        return Promise.resolve()
            .then(function () {
            if (!_this._config.serviceRegistration)
                return;
            return _this._dynaNodeClient.changeConnectionId({
                serverDynaNodeAddress: _this._config.serviceRegistration.serverDynaNodeAddress,
                newConnectionId: _this._config.serviceRegistration.serviceConnectionId,
                encryptionKey: _this._config.serviceRegistration.encryptionKey,
                accessKey: _this._config.serviceRegistration.accessKey,
                requestExpirationInMinutes: _this._config.serviceRegistration.requestExpirationInMinutes || 0.5,
            });
        })
            .then(function () {
            _this._serviceRegistered = true;
            _this._isServiceRegistering = false;
        })
            .catch(function (error) {
            _this._serviceRegistered = false;
            _this._isServiceRegistering = false;
            _this._config.onServiceRegistrationFail && _this._config.onServiceRegistrationFail(error);
            return Promise.reject(error || unknownError_1.unknownError(1810191208, 'DynaNodeService/_serviceRegistration'));
        });
    };
    DynaNodeService.prototype._handleIncomingMessage = function (message, isInternalSendToMe) {
        var priorityValue;
        if (!this._validateIncomingMessage(message, isInternalSendToMe))
            return; // exit, is invalid, error message already send from the validation function
        if (message.args && message.args.serviceMessagePriorityValue !== undefined) {
            priorityValue = message.args.serviceMessagePriorityValue;
        }
        else {
            priorityValue =
                this._config.defaultsServiceMessagePriorityValue === undefined
                    ? 1000
                    : this._config.defaultsServiceMessagePriorityValue;
        }
        if (priorityValue === 0) { // Highest priority, execute immediately in parallel without using the Queue.
            message._addTrace('DynaNode/Service/DIRECT_PROCESS', 'Message is processes immediately due to serviceMessagePriorityValue === 0');
            this._processMessage(message);
            return;
        }
        message._addTrace('DynaNode/Service/TO_QUEUE', 'DynaNode: DynaNodeService adding message to queue', __assign(__assign({}, this._traceData), { newQueueCount: this._messagesQueue.jobsCount + 1, priorityValue: priorityValue, serviceInternalId: this._internalId }));
        this._messagesQueue.addJob(message.pack().packet, priorityValue)
            .catch(this._config.onMessageQueueError);
    };
    DynaNodeService.prototype._validateIncomingMessage = function (message, isInternalSendToMe) {
        var commandIsSupported = !!this._config.onCommand[message.command];
        var commandIsPublic = this._config.publicCommands
            && this._config.publicCommands.includes(message.command);
        if (isInternalSendToMe && commandIsSupported) {
            return true;
        }
        if (isInternalSendToMe && !commandIsSupported) {
            var error = {
                code: 1811030845,
                section: '_validateIncomingMessage',
                message: "Internal message requires command " + message.command + " that is not supported at all.",
            };
            message._addTrace('DynaNode/Service/INCOMING_INVALID_400_103', 'DynaNode: DynaNodeService the message is invalid and rejected (without reply)', __assign(__assign({}, this._traceData), { error: error }));
            this._replyValidationError(message, 'error/dyna-node/400/103', error);
            return false;
        }
        if (commandIsSupported && !commandIsPublic) {
            var error = {
                code: 400.104,
                section: '_validateIncomingMessage',
                message: "The " + message.command + " is supported but is not public.",
            };
            message._addTrace('DynaNode/Service/INCOMING_INVALID_400_104', 'DynaNode: DynaNodeService the message is invalid and rejected (without reply)', __assign(__assign({}, this._traceData), { error: error }));
            this._replyValidationError(message, 'error/dyna-node/400/104', error);
            return false;
        }
        return true;
    };
    DynaNodeService.prototype._replyValidationError = function (sourceMessage, command, validationError) {
        var _this = this;
        validationError.data = validationError.data || {};
        validationError.data.sourceMessage = {
            from: sourceMessage.from,
            to: sourceMessage.to,
            command: sourceMessage.command,
        };
        this._dynaNodeClient
            .reply(sourceMessage, {
            command: command,
            data: validationError,
            updateReplyOfArgs: true,
            updateReplyOfData: true,
            updateReplyOf: true,
        })
            .catch(function (sendError) {
            console.error("DynaNodeService [" + _this.friendlyName + "]: Error 1811301978 _replyOrReportError: Cannot reply the error.", {
                sourceMessage: sourceMessage.viewSecure,
                validationError: validationError,
                sendError: sendError,
            });
        });
    };
    DynaNodeService.prototype._processMessage = function (message) {
        var _this = this;
        var commandConfig;
        return Promise.resolve()
            .then(function () {
            message._addTrace('DynaNode/Service/PROCESS_START', 'DynaNode: DynaNodeService is processing the message');
        })
            // check if the client doesn't exist anymore (his connection is closed/lost)
            .then(function () {
            if (!!_this._config.serviceRegistration &&
                message.from === _this._config.serviceRegistration.serverDynaNodeAddress &&
                isCommand_1.isCommandError404(message.command)) {
                if (_this._config.onClientConnectionLost && message.replyOf)
                    _this._config.onClientConnectionLost(message.replyOf);
                return Promise.reject({
                    code: 0,
                    message: 'client connection lost, request discarded',
                });
            }
            return Promise.resolve();
        })
            .then(function () {
            if (_this._config.onBeforeAnyCommand) {
                return _this._config.onBeforeAnyCommand(message)
                    .catch(function () { return Promise.reject({ code: 0 }); }); // code: 0 means swallow the error, since we want to discard the message
            }
            else {
                return Promise.resolve();
            }
        })
            // check if there is an implementation for this command
            .then(function () {
            commandConfig =
                _this._config.onCommand[message.command]
                    || _this._config.onUnknownCommand
                    || _this._handleUnknownCommand;
        })
            .then(function () {
            return new Promise(function (resolve, reject) {
                var timeout = commandConfig.executionTimeout || _this._config.defaultExecutionTimeout;
                var timeoutExpired = false;
                var executionTimer;
                var startExecutionTimeoutTimer = function () {
                    clearTimeout(executionTimer);
                    var timeout = commandConfig.executionTimeout || _this._config.defaultExecutionTimeout;
                    executionTimer = setTimeout(function () {
                        timeoutExpired = true;
                        _this._dynaNodeClient
                            .reply(message, {
                            command: 'error/dyna-node/507/307',
                            data: {
                                code: 507.307,
                                errorType: dyna_interfaces_1.EErrorType.APP,
                                message: "DynaNodeService, execution timeout for the command/request [" + message.command + "], timeout: " + timeout + "ms",
                            },
                        })
                            .catch(function () { return undefined; }); // ignore the send error of this message
                        reject({
                            code: 507.307,
                            message: "DynaNodeService, execution timeout for the command/request [" + message.command + "], timeout: " + timeout + "ms",
                            errorType: dyna_interfaces_1.EErrorType.APP,
                            data: {
                                executionTimeout: commandConfig.executionTimeout || 'not-defined',
                                serviceConfigDefaultExecutionTimeout: _this._config.defaultExecutionTimeout || 'not-defined',
                            },
                        });
                    }, timeout);
                };
                startExecutionTimeoutTimer();
                try {
                    // THandleIncomingMessage type function
                    commandConfig.execute({
                        message: message,
                        isActive: function () { return _this._active; },
                        isReady: function () { return _this._ready; },
                        send: function (config) { return _this.send(config); },
                        sendReceive: function (config) { return _this.sendReceive(config); },
                        sendToMe: function (config) { return _this.sendToMe(config); },
                        reply: function (config) { return _this.reply(message, config); },
                        resetExecutionTimer: function () { return startExecutionTimeoutTimer(); },
                        dynaNodeClient: _this._dynaNodeClient,
                        next: function () {
                            clearTimeout(executionTimer);
                            if (timeoutExpired)
                                return; // is rejected already
                            resolve();
                        },
                    });
                }
                catch (error) {
                    if (executionTimer)
                        clearTimeout(executionTimer);
                    var reportError = {
                        code: 1807140829,
                        message: "General error executing command [" + message.command + "]",
                        errorType: dyna_interfaces_1.EErrorType.APP,
                        error: {
                            message: error.message,
                        },
                    };
                    if (timeoutExpired) {
                        console.error("DynaNodeService [" + _this.friendlyName + "]: Error 1807151021 ProcessMessage, command [" + message.command + "] failed and the execution timeout exceeded (" + timeout + "ms) so the client is not aware of this error", consoleStringify_1.consoleStringify({ reportError: reportError, message: message.viewSecure }));
                    }
                    else {
                        reject(reportError);
                    }
                }
            });
        })
            .catch(function (error) {
            if (error.code !== undefined && error.code !== 0) {
                console.error("DynaNodeService [" + _this.friendlyName + "]: Error 1801011651 Command execution general error", consoleStringify_1.consoleStringify(error));
            }
        })
            .then(function () { return undefined; });
    };
    Object.defineProperty(DynaNodeService.prototype, "_traceData", {
        get: function () {
            return {
                prefixAddress: this._config.prefixAddress || '-no prefix-',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeService.prototype, "_debug_dynaNodeClient", {
        get: function () {
            return this._dynaNodeClient;
        },
        enumerable: true,
        configurable: true
    });
    return DynaNodeService;
}());
exports.DynaNodeService = DynaNodeService;
//# sourceMappingURL=DynaNodeService.js.map